// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".social-button{height:80px;width:80px;border-radius:50%;text-align:center;color:#fff;line-height:80px;font-size:28px;list-style-type:none}.social-button:hover{background-color:var(--almost-black)}", ""]);
// Exports
module.exports = exports;
